import { Editor } from 'grapesjs';
import { facRewardHistory } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from '../types';
import {
  RewardsWonTableGrapesComponent,
  rewardsWonTableComponentDefinition,
} from './rewards-won-table-grapes-component';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const rewardsWonComponentDefinition: EditorComponentDefinition = {
  id: 'rewards-won',
  icon: facRewardHistory,
  category: 'Loyalty',
  getLabel: ({ t }) => t('editor.component.rewards-won'),
  component: RewardsWonGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
};

export function RewardsWonGrapesComponent(editor: Editor) {
  const languages = editor.Config?.context?.languages || [];

  RewardsWonTableGrapesComponent(editor);

  editor.DomComponents.addType(rewardsWonComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-rewards-won');
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.rewards-won.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: rewardsWonTableComponentDefinition.id,
          },
        ],
        attributes: {
          class: 'qlfeditor-rewards-won',
          tagName: 'section',
          'aria-label': 'aria.rewards-won.label',
          'aria-description': 'aria.rewards-won.description',
        },
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
